import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ExternalRefTemplateModel, TemplateRequest, TemplateResponse } from "../_models";
import { HttpUtilsService } from "../../_base/crud";
import { map } from "rxjs/operators";
import { MadAuthService } from "../../mad-auth/mad-auth.service";
import { SubdomainService } from "../../_base/subdomain.service";


@Injectable()
export class ExternalRefTemplateService {
    API_URL = environment.baseApiUrl + `api/${this.subDomainService.subDomain}/templates/external-ref`;
    constructor (
        private http: HttpClient,
        private authService: MadAuthService,
        private subDomainService: SubdomainService
    ) {}

    getAll(request: TemplateRequest): Observable<TemplateResponse<ExternalRefTemplateModel>> {
        const headers = this.authService.getAuthHeaders();
        const params = new HttpParams()
            .set("page", request.pageNumber.toString())
            .set("pageSize", request.pageSize.toString());

        return this.http.get<{
            data: ExternalRefTemplateModel[],
            pagination: {
                total: number
            }
        }>(this.API_URL, {
            headers,
            params
        }).pipe(
            map(res => {
                const tres: TemplateResponse<ExternalRefTemplateModel> = {
                    templates: res.data,
                    total: res.pagination.total
                }
                return tres;
            })
        )
    }

    get(id: number): Observable<ExternalRefTemplateModel> {
        const headers = this.authService.getAuthHeaders();
        return this.http.get<{data: ExternalRefTemplateModel}>(this.API_URL + `/${id}`, {headers}).pipe(
            map(res => res.data)
        );
    }

    create(template: ExternalRefTemplateModel): Observable<ExternalRefTemplateModel> {
        const headers = this.authService.getAuthHeaders();
        return this.http.post<{data: ExternalRefTemplateModel}>(this.API_URL, template, {headers}).pipe(map(res => res.data));
    }

    update(id: number, template: ExternalRefTemplateModel): Observable<ExternalRefTemplateModel> {
        const headers = this.authService.getAuthHeaders();
        return this.http.put<{data: ExternalRefTemplateModel}>(this.API_URL + `/${id}`, template, {headers}).pipe(map(res => res.data));
    }

    delete(id: number): Observable<{sucess: boolean, id: number}> {
        const headers = this.authService.getAuthHeaders();
        return this.http.delete<{sucess: boolean, id: number}>(this.API_URL + `/${id}`, {headers});
    }

    duplicate(template: ExternalRefTemplateModel): Observable<ExternalRefTemplateModel> {
        const headers = this.authService.getAuthHeaders();
        return this.http.post<{data: ExternalRefTemplateModel}>(this.API_URL + '/duplicate', template, {headers}).pipe(map(res => res.data));
    }
}